<div class="modern-landing">
  <!-- Navigation Component -->
  <app-home-navbar
    [isScrolled]="isScrolled"
    [currentTheme]="currentTheme"
    [availableThemes]="availableThemes"
    [isMenuOpen]="isMenuOpen"
    [isDropdownOpen]="isDropdownOpen"
    (smoothScrollEvent)="smoothScroll($event)"
    (toggleMenuEvent)="toggleMenu()"
    (toggleDropdownEvent)="toggleDropdown()"
    (selectThemeEvent)="selectTheme($event)">
  </app-home-navbar>

  <!-- Hero Component -->
  <app-home-hero
    [quickStats]="quickStats"
    (playVideoEvent)="playVideo()">
  </app-home-hero>

  <!-- Video Demo Component -->
  <app-home-video-demo
    [isPlaying]="isPlaying"
    [videoPath]="videoPath"
    (playMainVideoEvent)="playMainVideo()"
    (closeVideoEvent)="closeVideo()"
    #videoSection>
  </app-home-video-demo>

  <!-- Stats Component -->
  <app-home-stats
    [achievements]="achievements">
  </app-home-stats>

  <!-- Features Component -->
  <app-home-features
    [platformFeatures]="platformFeatures">
  </app-home-features>

  <!-- User Segments Component -->
  <app-home-user-segments
    [userSegments]="userSegments">
  </app-home-user-segments>

  <!-- About Component -->
  <app-home-about
    [aboutHighlights]="aboutHighlights">
  </app-home-about>

  <!-- Educational Offerings Component -->
  <app-home-educational-offers
    [educationalServices]="educationalServices">
  </app-home-educational-offers>

  <!-- Pricing Component -->
  <app-home-pricing
    [educationalOffers]="educationalOffers">
  </app-home-pricing>

  <!-- Team Component -->
  <app-home-team
    [staffMembers]="staffMembers">
  </app-home-team>

  <!-- Content Component -->
  <app-home-content
    [contentCategories]="contentCategories">
  </app-home-content>

  <!-- Testimonials Component -->
  <app-home-testimonials
    [testimonials]="testimonials"
    [currentTestimonialIndex]="currentTestimonialIndex"
    [isTransitioning]="isTransitioning"
    [isAutoplayPaused]="isAutoplayPaused"
    [autoplayDuration]="autoplayDuration"
    (nextTestimonialEvent)="nextTestimonial()"
    (prevTestimonialEvent)="prevTestimonial()"
    (goToTestimonialEvent)="goToTestimonial($event)"
    (pauseAutoplayEvent)="pauseAutoplay()"
    (resumeAutoplayEvent)="resumeAutoplay()">
  </app-home-testimonials>

  <!-- Final CTA Component -->
  <app-home-final-cta
    (smoothScrollEvent)="smoothScroll($event)">
  </app-home-final-cta>

  <!-- Footer Component -->
  <app-home-footer></app-home-footer>
</div>